import { render, staticRenderFns } from "./CreateTab.vue?vue&type=template&id=5a1ef34a&scoped=true"
import script from "./CreateTab.vue?vue&type=script&lang=js"
export * from "./CreateTab.vue?vue&type=script&lang=js"
import style0 from "./CreateTab.vue?vue&type=style&index=0&id=5a1ef34a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ef34a",
  null
  
)

export default component.exports